import { Link } from 'react-router-dom';
import CookieBanner from './CookieBanner';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const servicios = [
    'Vaciado de Pisos y Casas',
    'Vaciado de Locales',
    'Retirada de Muebles',
    'Limpieza Diógenes',
    'Pintura Final',
    'Pequeñas Reparaciones',
  ];

  const enlaces = [
    { path: '/', label: 'Inicio' },
    { path: '/empresa', label: 'Empresa' },
    { path: '/servicios', label: 'Servicios' },
    { path: '/faq', label: 'FAQ' },
    { path: '/contacto', label: 'Contacto' },
  ];

  return (
    <footer className="bg-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="lg:col-span-1">
            <div className="flex items-center mb-4">
              <span className="text-2xl font-bold text-primary">JUSTCLEAN</span>
              <span className="text-2xl font-bold text-white ml-2">MOLLET</span>
            </div>
            <p className="text-white/80 text-sm leading-relaxed mb-6">
              Empresa especializada en vaciado de pisos, locales y limpieza por síndrome de Diógenes en Mollet del Vallès y comarca del Vallès Oriental.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-primary transition-colors duration-200 cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-primary transition-colors duration-200 cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-primary transition-colors duration-200 cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-4">Enlaces</h3>
            <ul className="space-y-3">
              {enlaces.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-white/80 hover:text-primary transition-colors duration-200 text-sm"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-4">Servicios</h3>
            <ul className="space-y-3">
              {servicios.map((servicio, index) => (
                <li key={index}>
                  <Link
                    to="/servicios"
                    className="text-white/80 hover:text-primary transition-colors duration-200 text-sm"
                  >
                    {servicio}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-4">Contacto</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-phone-fill text-primary text-lg mt-0.5"></i>
                <div>
                  <a href="tel:+34602365996" className="text-white/80 hover:text-primary transition-colors duration-200 text-sm cursor-pointer">
                    602 36 59 96
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-fill text-primary text-lg mt-0.5"></i>
                <div>
                  <a href="mailto:info@mollet.justclean.es" className="text-white/80 hover:text-primary transition-colors duration-200 text-sm cursor-pointer">
                    info@mollet.justclean.es
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-time-fill text-primary text-lg mt-0.5"></i>
                <div className="text-white/80 text-sm">
                  <p>Lun-Vie: 8:00-20:00</p>
                  <p>Sáb: 9:00-14:00</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-fill text-primary text-lg mt-0.5"></i>
                <div className="text-white/80 text-sm">
                  <p>Mollet del Vallès, Parets,</p>
                  <p>Montmeló, Granollers...</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/70 text-sm text-center md:text-left">
              © {currentYear} JUSTCLEAN Mollet del Vallès. Todos los derechos reservados.
            </p>
            <div className="flex flex-wrap justify-center md:justify-end items-center gap-4 text-sm">
              <a href="#" className="text-white/70 hover:text-primary transition-colors duration-200">
                Aviso Legal
              </a>
              <span className="text-white/30">|</span>
              <a href="#" className="text-white/70 hover:text-primary transition-colors duration-200">
                Política de Privacidad
              </a>
              <span className="text-white/30">|</span>
              <a href="#" className="text-white/70 hover:text-primary transition-colors duration-200">
                Política de Cookies
              </a>
              <span className="text-white/30">|</span>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-white/70 hover:text-primary transition-colors duration-200"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>

      <CookieBanner />
    </footer>
  );
};

export default Footer;